import React, { useEffect, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import axios from 'axios';
import moment from 'moment';
import './css/index.scss';
import {
	CCard, CCol, CRow, CCardHeader,
	CCardTitle, CCardText, CCardBody,
	CCardSubtitle, CImage, CFooter, CBadge, CButton, CDataTable, CDropdown, CDropdownToggle, CDropdownMenu,
	CPagination, CModal, CModalHeader, CModalBody,
	CModalFooter, CForm, CFormGroup, CFormText, CDropdownItem,
	CLabel, CInput, CInputGroup, CInputGroupText, CButtonGroup,
} from 'compat/coreui';
import tawkTo from "tawkto-react";
import { IMAGE_URL } from '../Constants/constants';

// import $ from 'jquery';
const $ = window.$;

export default function Homepage(props) {
	const navigate = useNavigate()
	const user = useSelector(state => state.user)
	const [pin, setPin] = useState('');
	const [sellerData, setSellerData] = useState([]);
	const [reviewData, setReviewData] = useState([]);
	const [modal, setModal] = useState(false);

	const searchHandler = (e) => {
		e.preventDefault();
		const params = {
			// pincode: pin,
			sr: pin,
		}
		navigate("/virginia", { state: params })
	}
	const searchHandlerRedirect = (e, search) => {
		e.preventDefault()
		const params = {
			pincode: pin,
			sr: search,
		}
		navigate("/search", { state: params })
	}
	const submitYes = () => {
		setModal(!modal)
	}
	const submitNo = () => {
		window.location.replace("http://google.com/");
	}
	useEffect(() => {
		// tawkTo("605b8c40067c2605c0bbea8a", "d3cf47c5df96fbdc3d15ad878ecdd3b3c3f7b12c")
		const date = localStorage.getItem('date')
		const now = moment().format('YYYY-MM-DD')
		console.log(date)
		if (date === null) {
			localStorage.setItem('date', now)
			setModal(true)
		} else if (date !== now) {
			localStorage.setItem('date', now)
			setModal(true)
		}
		getBusiness();
		try {
			$('.owl-carousel').owlCarousel({
				items: 3,
				loop: true,
				margin: 10,
				dots: false,
				nav: true,
				//autoplay:true,
				mouseDrag: true,
				responsiveClass: true,
				responsive: {
					0: {
						items: 1,
						nav: true
					},
					600: {
						items: 3,
						nav: false
					},
					1000: {
						items: 3,
						nav: true,
						loop: false,
						margin: 20
					}
				}
			});
			$(".owl-prev").html('<img  src="images/aro-l.png">');
			$(".owl-next").html('<img  src="images/aro-r.png">');
		} catch (e) {
			console.log(e)
		}
	}, [])

	const getBusiness = () => {
		const paramsOne = {
			pincode: "",
			sr: "",
		}
		axios.get(`${process.env.REACT_APP_APP_API_URL}/api/sellers`, {
			headers: {
				Authorization: 'Bearer ' + localStorage.getItem('token')
			},
			params: paramsOne
		}).then(res => {
			if (res.data.status === 200) {
				// console.log("============>>>", res.data.sellers);
				setSellerData(res.data.sellers)
				setReviewData(res.data.reviews)
			}
		}).catch(console.log)
	}

	return (

		<React.Fragment>

			<CModal
				show={modal}
				className="jp-age-gate"
			>
				<CModalBody>
					<CCol className="text-center">
						<CCol>
							<h1>Are you at least 21 years of age or a valid medical marijuana patient?</h1>
						</CCol>
						<CRow >
							<div style={{ marginLeft: "auto", marginRight: "auto" }}>
								<CButton className="btn-green" onClick={() => submitYes()}>YES</CButton>
								<CButton className="jp-btn-hot" onClick={() => submitNo()}>NO</CButton>
							</div>
						</CRow>
						<CCol>
							<h4>Joint Plug strives to abide by all state laws and regulations in regards to access to cannabis.</h4>
						</CCol>
					</CCol>
				</CModalBody>
			</CModal>

			<div className="banner-video">
				<div className="video-container" >
					<video style={{ objectFit: "cover", height: "100vh" }} width="100%" loop autoPlay muted playsInline preload="auto" >
						<source src={`${process.env.REACT_APP_IMAGE_URL}/media/videoHome.mp4`} type="video/mp4" />
					</video>
				</div>
				<div className="bnrscearch">
					<span className="jp-hero-badge">✦ #1 Cannabis Marketplace</span>
					<h1 className="heading1">Discover Trusted <span className="jp-gradient-text">Cannabis</span><br />Businesses in Your Community</h1>
					<p>Dispensaries, deliveries, deals &amp; doctors — all in one place.</p>
					<form className="bnr-search" onSubmit={searchHandler}>
						<div className="input-group">
							<span className="jp-search-icon" aria-hidden="true">
								<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round"><circle cx="11" cy="11" r="7"/><path d="m21 21-4.3-4.3"/></svg>
							</span>
							<input type="text" className="form-control" placeholder="Enter your city or zip code…" onChange={(e) => setPin(e.target.value)} />
							<div className="input-group-prepend" onClick={searchHandler}>
								<button style={{ minHeight: "33px", height: "auto" }} className="btn tobtn-green" >SEARCH</button>
							</div>
						</div>
					</form>
					<div className="jp-hero-stats">
						<div><strong>500+</strong><span>Businesses</span></div>
						<i />
						<div><strong>10k+</strong><span>Happy Customers</span></div>
						<i />
						<div><strong>4.8★</strong><span>Average Rating</span></div>
					</div>
				</div>
				<div className="jp-scroll-hint" aria-hidden="true"><span /></div>
			</div>

			<div className="suggested-container " >
				<div className="container">
					<div className="suggested-text-home-page">
						<p>Suggested in Washington</p>
					</div>
					<div className="suggested-iteams-container">
						<div className="suggested-iteams">
							<a href="/#" onClick={e => {searchHandlerRedirect(e, 'Strains')}}>
								<img alt='' src="images/11.png" />
								<label>Strains</label>
							</a>
						</div>
						<div className="suggested-iteams">
							<a href="/#" onClick={e => {searchHandlerRedirect(e, 'Deals')}}>
								<img alt='' src="images/22.png" />
								<label>Deals</label>
							</a>
						</div>
						<div className="suggested-iteams">
							<a href="/#" onClick={e => {searchHandlerRedirect(e, 'Recreational')}}>
								<img alt='' src="images/33.png" />
								<label>Recreational</label>
							</a>
						</div>
						<div className="suggested-iteams">
							<a href="/#" onClick={e => {searchHandlerRedirect(e, 'Dispensaries')}}>
								<img alt='' src="images/44.png" />
								<label>Dispensaries</label>
							</a>
						</div>
						<div className="suggested-iteams">
							<a href="/#" onClick={e => {searchHandlerRedirect(e, 'Deliveries')}}>
								<img alt='' src="images/55.png" />
								<label>Deliveries</label>
							</a>
						</div>
						<div className="suggested-iteams">
							<a href="/#" onClick={e => {searchHandlerRedirect(e, 'Doctors')}}>
								<img alt='' src="images/66.png" />
								<label>Doctors</label>
							</a>
						</div>
					</div>
				</div>
			</div>

			<div className="main_cta_slide">
				<div className="wrapper">
					<div className="heading">marijuana dispensaries, delivery and<br /> doctors in washington 2001</div>
				</div>
			</div>

			<div className="product-container">
				<div className="homepage-seller-details">
					<CRow>
						{sellerData.map((item, index) => {
							return (<CCol sm="3" className="m-auto" key={index}>
								<Link to={"/businessnew/" + item._id}>
									<CCard>
										<CCardHeader className="p-0 b-header">
											<CImage style={{ maxHeight: "132px" }} src={item.coverImage ? IMAGE_URL + item.coverImage : "/images/product-1.jpg"} width="100%"></CImage>
										</CCardHeader>
										<CCardBody className="text-center">
											<div className="b-pic">
												{item.image ? <img src={IMAGE_URL + item.image} /> : <img src="/images/product-1.jpg" />}
											</div>
											<div className="text-align header_title">
												<CCardTitle>
													<p>{item.businessName}</p>
													<span className="jp-card-type">{item.businessType}</span><br />
													<span className="jp-stars" aria-label="rating">★★★★★</span>
												</CCardTitle>
											</div>
										</CCardBody>
									</CCard>
								</Link>
							</CCol>)
						})}
					</CRow>
				</div>
			</div>

			{(!user.email) && <div className="container">
				<div className="now-to text-center margin-bottom-70">
					<h1 className="heading1 margin-top-50 m-margin-top-30 margin-bottom-30 m-margin-bottom-20">New to <span className="jp-gradient-text">JointPlug</span>?</h1>
					<p>Our state-of-the-art marketplace for cannabis delivery is built on a peer-to-peer voting system, vetting both businesses and customers. Live order tracking shows you exactly what stage your order is on. Security is key for both our vendors and customers, so we strictly enforce proper vetting.</p>
				</div>

				<div className="row">
					<div className="col-md-8">
						<h1 className="heading1" onClick={() => {
							navigate('/join')
						}}>Create an Account</h1>
						<div className="row">
							<div className="col-md-6">
								<div className="ct-hld">
									<img alt="true" src="images/ic1.png" />
									<p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
								</div>
							</div>
							<div className="col-md-6">
								<div className="ct-hld">
									<img alt="true" src="images/ic2.png" />
									<p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
								</div>
							</div>
							<div className="col-md-6">
								<div className="ct-hld">
									<img alt="true" src="images/ic3.png" />
									<p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
								</div>
							</div>
							<div className="col-md-6">
								<div className="ct-hld">
									<img alt="true" src="images/ic4.png" />
									<p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
								</div>
							</div>
						</div>
					</div>
					<div className="col-md-4">
						<div className="crear-login">
							<h1 className="heading1">Login:</h1>
							<ul>
								<li><a href="/#"><img alt="true" src="images/fb.png" /></a></li>
								<li><a href="/#"><img alt="true" src="images/twt.png" /></a></li>
								<li><a href="/#"><img alt="true" src="images/gpl.png" /></a></li>
							</ul>
							<p>Don't Have Account</p>
							<button className="btn btn-green creat-btn" onClick={() => {
								navigate('/join')
							}}>Create an Account</button>
						</div>
					</div>
				</div>
			</div>}
			<div className="black-bg">
				<h1 className="heading1">Marijuana News & Events</h1>

				<div className="container" >
					<div className="owl-carousel owl-theme">


						<div className="item">
							<div className="thumbnail">
								<img alt="true" src="images/tumpnail.png" />
								<div className="caption">
									<p>October 27, 2020</p>
									<h4>How These 7 Amazing Women Changed the weed Industry?</h4>
									<p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Facere, soluta, eligendi doloribus sunt minus amet sit debitis repellat. Consectetur, culpa itaque odio similique suscipit</p>
									<a href="/#" className="btn btn-green" role="button">VIEW EVENT</a>
								</div>
							</div>
						</div>
						<div className="item">
							<div className="thumbnail">
								<img alt="true" src="images/tumpnail.png" />
								<div className="caption">
									<p>October 27, 2020</p>
									<h4>How These 7 Amazing Women Changed the weed Industry?</h4>
									<p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Facere, soluta, eligendi doloribus sunt minus amet sit debitis repellat. Consectetur, culpa itaque odio similique suscipit</p>
									<a href="/#" className="btn btn-green" role="button">VIEW EVENT</a>
								</div>
							</div>
						</div>

						<div className="item">
							<div className="thumbnail">
								<img alt="true" src="images/tumpnail.png" />
								<div className="caption">
									<p>October 27, 2020</p>
									<h4>How These 7 Amazing Women Changed the weed Industry?</h4>
									<p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Facere, soluta, eligendi doloribus sunt minus amet sit debitis repellat. Consectetur, culpa itaque odio similique suscipit</p>
									<a href="/#" className="btn btn-green" role="button">VIEW EVENT</a>
								</div>
							</div>
						</div>

						<div className="item">
							<div className="thumbnail">
								<img alt="true" src="images/tumpnail.png" />
								<div className="caption">
									<p>October 27, 2020</p>
									<h4>How These 7 Amazing Women Changed the weed Industry?</h4>
									<p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Facere, soluta, eligendi doloribus sunt minus amet sit debitis repellat. Consectetur, culpa itaque odio similique suscipit</p>
									<a href="/#" className="btn btn-green" role="button">VIEW EVENT</a>
								</div>
							</div>
						</div>

						<div className="item">
							<div className="thumbnail">
								<img alt="true" src="images/tumpnail.png" />
								<div className="caption">
									<p>October 27, 2020</p>
									<h4>How These 7 Amazing Women Changed the weed Industry?</h4>
									<p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Facere, soluta, eligendi doloribus sunt minus amet sit debitis repellat. Consectetur, culpa itaque odio similique suscipit</p>
									<a href="/#" className="btn btn-green" role="button">VIEW EVENT</a>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>


			<div className="container">
				<div className="row get-app">
					<div className="col-md-6">
						<img alt="true" src="images/app-image.png" className="apimg" />
					</div>
					<div className="col-md-6">
						<h1 className="heading1 margin-bottom-18 m-margin-bottom-18 m-margin-top-18">Get the App</h1>
						<p className="discover margin-bottom-50 m-margin-bottom-20">Discover local businesses. Find the best deals.<br /> Connect & share wih friends.</p>
						<a href="/#" className="margin-right-20 pull-left"><img alt="true" src="images/ply-str.png" /></a>
						<a href="/#" className="margin-right-20 pull-left"><img alt="true" src="images/ply-str.png" /></a>
						<a href="/#" className="margin-right-20 pull-left"><img alt="true" src="images/ply-str.png" /></a>
					</div>
				</div>
			</div>

			<div className="product-container homepage-seller-details m-auto">
				<CRow className="mt-3 mb-5">
					{reviewData.map((item, index) => {
						return (<CCol lg={4} sm={3} key={index}>
							<CCard className="review_card">
								<div className="review_text">
									<p>{item.msg}</p>
								</div>
								<div className="review_author">
									<CImage src={item.reviewed ? IMAGE_URL + item.reviewed.image : "/images/product-1.jpg"} />
									<div className="author"><a href="/">{item.reviewer ? item.reviewer.businessName : ""}</a> reviewed <a href="/">{item.reviewed ? item.reviewed.businessName : ""}</a></div>
									<div className="review_stars">
										<span >
											<span className="stars_full" style={{ width: '100%' }}>
												<div className="some_img">
													{Array(item.rating).fill(1).map((el, i) =>
														<CImage src="/images/11.png" key={i}/>
													)}
												</div>
											</span>
										</span>
									</div>
								</div>
							</CCard>
						</CCol>
						)
					})}
				</CRow>
			</div>
			
		</React.Fragment>
	)
}
